import { FunctionComponent } from 'react';

import { Notification } from '@savgroup-front-common/types';

import BannerBaseWithAnimation from './BannerBaseWithAnimation';
import { $MultiBanners } from './MultiBanners.styles';

interface MultiNotificationsProps {
  notifications: Notification[];
  isFluid?: boolean;
}

const MultiBanners: FunctionComponent<MultiNotificationsProps> = ({
  notifications = [],
  isFluid = false,
}) => {
  if (notifications.length === 0) {
    return null;
  }

  return (
    <$MultiBanners>
      {notifications.map(
        ({
          id,
          children,
          notificationType,
          options,
          onClose,
          isFluid: innerIsFluid = isFluid,
        }) => (
          <BannerBaseWithAnimation
            key={id}
            isFluid={innerIsFluid}
            dataTestId={id}
            hollow={options?.hollow}
            onClose={onClose}
            notificationType={notificationType}
          >
            {children}
          </BannerBaseWithAnimation>
        ),
      )}
    </$MultiBanners>
  );
};

export default MultiBanners;
